import { LocalizedText } from '@mews/framework';
import { OptimusPlainLink } from '@mews-commander/ui';
import { IconName } from '@optimus-web/core';
import { NavbarIconButton } from '../../../../components';

interface Props {
    url: string;
    onClick(): void;
    icon: IconName;
    title: Mews.TextKey;
    shortcut?: string;
}

const AnchorButton = ({ url, onClick, icon, title, shortcut, ...other }: Props) => {
    const tooltip = (
        <span>
            <LocalizedText textKey={title} />
            <br />
            {shortcut}
        </span>
    );
    return (
        <OptimusPlainLink href={url} onClick={onClick} inherit>
            <NavbarIconButton icon={icon} title={tooltip} {...other} />
        </OptimusPlainLink>
    );
};

export default AnchorButton;
